import { Container, Box, Button, Grid, Stack } from "@mui/material";
import { CHATBOT_WEBSITE_NAME } from "../../constants";
import GpscAuraLogo from "../../components/GpscAuraLogo/GpscAuraLogo";
import { Link, useNavigate } from "react-router";
import { useLayoutEffect } from "react";

function LandingPage() {
    const scrollToElement = (elementId: string) => {
        const element = document.getElementById(elementId);
        element?.scrollIntoView({ behavior: "smooth" });
    };
    const navigate = useNavigate();

    // This permanently routes the 'home' page to the 'chat' page after 'Get started' has been clicked.
    // TODO: Once fusion is updated from 1.0.0 to 4.0.2 (for a bugfix), this can be updated to the version in the package-upgrades branch
    //      which will allow disabling this auto-redirect when someone manually visits the homepage again.
    //      It will be re-enabled when they click the 'Get Started' button again. (though the whole thing might be too much/not needed)
    useLayoutEffect(() => {
        const hasSeenIntroPage = localStorage.getItem("hasSeenIntroPage");
        if (hasSeenIntroPage == "true") {
            navigate("/chat");
        }
    }, [navigate]);

    return (
        <Container>
            <Box display="flex" flexDirection="column" alignItems="center" flexGrow="1" justifyContent="center" minHeight="calc(100vh - 48px - 64px)">
                <Grid container spacing={3} justifyContent="center">
                    <Grid
                        item
                        xs={12}
                        md={8}
                        lg={7}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                        }}
                    >
                        <GpscAuraLogo variant="large" />
                        <Box component="h3" sx={{ fontSize: "2rem", color: "secondary.main", margin: 0 }}>
                            Global Purchasing Supply Chain AI Assistant
                        </Box>
                        <Box component="p" sx={{ fontSize: "1rem", color: "text.secondary", margin: 0, marginTop: 2 }}>
                            {CHATBOT_WEBSITE_NAME} harnesses the power of agentic AI to assist you with daily activities.
                        </Box>
                        <Stack direction="row" spacing={2} justifyContent="center" sx={{ marginTop: "20px", width: "100%" }}>
                            <Link to="/info" style={{ textDecoration: "none" }}>
                                <Button size="large" variant="contained" color="primary"
                                        onClick={() => {
                                            localStorage.setItem("hasSeenIntroPage", "true");
                                            scrollToElement("tipsAndTricks")
                                        }}>
                                    Get Started
                                </Button>
                            </Link>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}

export default LandingPage;
